import { css } from "styled-components";

import { Palette } from "../../../core/styles/theme";
import { TableColumnWidth } from "../types/types";

export const tableStyle = css`
    &.aevi-table-container {
        width: 100%;
        overflow-x: scroll;
    }

    &.aevi-table {
        overflow-x: scroll;
        text-align: left;
        overflow-y: hidden;

        &.aevi-table thead tr {
            //height: 40px;
            //font-family: "RobotoMedium";
            //padding: 6px;
            //border: none;

            //th {
            //    padding-left: 16px;
            //    vertical-align: middle;
            //}
        }

        &.aevi-table tbody tr:nth-child(odd) td {
            background-color: ${Palette.DisabledBackground};
        }

        &.aevi-table tbody tr:nth-child(even) td {
            background-color: ${Palette.White};
        }

        &.aevi-table tbody tr:nth-child(even):hover {
            & td {
                background: ${Palette.HeroGreen};
                color: ${Palette.White};
            }
        }

        // rows
        &.aevi-table tbody tr {
            //height: 40px;
            //font-family: "RobotoLight";
            //padding: 6px;
            // row on hover
            &:hover {
                color: ${Palette.White};
                background-color: ${Palette.HeroGreen};
            }
        }

        // cells
        &.aevi-table td {
            //font-family: "RobotoLight";
            //font-size: 10pt;
            //line-height: 18pt;
            //cursor: pointer;
            //padding-left: 16px;
            //vertical-align: middle;
            // column width
            //max-width: ${TableColumnWidth.LARGE};
            //min-width: ${TableColumnWidth.SMALL};
            // single line text with overflow text as dots ...
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
        }
    }

    // &.aevi-table-pagination {
    //     display: flex;
    //     flex-direction: row;
    //     height: 32px;
    //     max-width: 500px;
    //     margin: 16px auto;
    //     justify-content: center;
    //
    //     ul {
    //         min-width: 300px;
    //         display: flex;
    //         flex-direction: row;
    //         justify-content: center;
    //         list-style-type: none;
    //     }
    //
    //     li {
    //         margin: 0 10px;
    //         display: flex;
    //
    //         a {
    //             font-family: RobotoMedium;
    //             color: ${Palette.AeviBlack};
    //             line-height: 32px;
    //             min-width: 32px;
    //             text-align: center;
    //             margin: 0 auto;
    //             border-radius: 6px;
    //
    //             :hover {
    //                 background-color: ${Palette.DisabledBackground};
    //             }
    //         }
    //     }
    //
    //     .aevi-table-pagination-active {
    //         color: ${Palette.HeroGreen};
    //     }
    //
    //     .aevi-table-pagination-disabled {
    //         fill: ${Palette.DisabledColor};
    //         cursor: not-allowed;
    //     }
    //
    //     svg {
    //         fill: ${Palette.FormText};
    //         scale: 80%;
    //     }
    // }
`;
